import { BranchViewModel } from "./BranchViewModel";

export const getLocalizedDataForBranches = (branches: Array<BranchViewModel>) => {
  return branches.map((b) => {
    return { text: b.Name, value: b.BranchID };
  });
};
